import classnames from 'classnames';
import { forwardRef } from 'react';
import CaptureManager from './CaptureManager/CaptureManager';
import CaptureManagerProvider, { CaptureManagerStateContext } from './CaptureManager/context';
import Webcam from './Webcam/Webcam';
import './WebcamRecorder.css';
import CaptureProvider from './Webcam/context';
import { CaptureHandle, WebcamRecorderProps } from './Webcam/context/type';
import { Button } from 'antd';
import { CloseOutlined } from '@vindr/icons';
import { useTranslation } from 'react-i18next';

const WebcamRecorder = forwardRef<CaptureHandle, WebcamRecorderProps>(
  (
    {
      study,
      assign,
      params,
      appearance = 'default',
      setRecording,
      actionUpload,
      open,
      modal,
      onSelect,
      onUploading,
      recordVideo,
      warningCloseCamera,
    },
    ref
  ) => {
    const { t } = useTranslation('Vindoc');
    if (!open) return null;

    const handleCloseCamera = () => {
      const onClose = () => {
        setRecording((draft) => {
          draft.open = !open;
          draft.recording = false;
        });
      };

      if (recordVideo.recording && recordVideo.open) {
        return warningCloseCamera(onClose);
      }
      onClose();
    };

    return (
      <div
        className={classnames('capture-video flex flex-col pb-0.5 lg:h-auto lg:overflow-hidden', {
          // 'lg:h-auto': selectedResolution.width < selectedResolution.height,
        })}
      >
        {appearance === 'default' && (
          <div className="flex justify-end">
            <Button className="flex items-center" size="small" onClick={handleCloseCamera}>
              <CloseOutlined className="color-white" />
              {t('Close Camera')}
            </Button>
          </div>
        )}
        <CaptureManagerProvider {...{ actionUpload, appearance, params, study, onUploading }}>
          <CaptureProvider setRecording={setRecording} ref={ref}>
            <CaptureManagerStateContext.Consumer>
              {(value) => (value.showCamera ? <Webcam /> : null)}
            </CaptureManagerStateContext.Consumer>
          </CaptureProvider>

          <CaptureManager modal={modal} onSelect={onSelect} />
        </CaptureManagerProvider>
      </div>
    );
  }
);

WebcamRecorder.displayName = 'WebcamRecorder';

export default WebcamRecorder;
